// extracted by mini-css-extract-plugin
export default {"checkbox":"checkbox-P4Wmc","checked":"checked-nM358"};